module.exports = __webpack_public_path__ + "media/images/flags/1x1/syr-940b670c036329f572b3d931e2136f9a.svg";